
// 3D cart drawer js start 18 July 2024 
window.addEventListener("Angle3DAddToCart", function(event) {
  //$('#cart-drawer').toggle();
  // $('#cart-drawer').attr('active','');
 //$('#cart-drawer').toggleAttr('open');
            var getValues = ('Angle3DAddToCart' + 
            JSON.stringify(event.detail));
            console.log('getValues'+getValues);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
   }));
  document.querySelector("[aria-controls='cart-drawer']").click();
  return false;
   
});
 
window.addEventListener("Angle3DCustomizerLoaded", function(event) {
            $('div#tda-customizer-customization-option-value-container-0b6wsue-r916p input[type="text"], div#tda-customizer-customization-option-value-container-0uvd3b-x157a input[type="text"], div#tda-customizer-customization-option-value-container-qh2kb-2vpxn input[type="text"], div#tda-customizer-customization-option-value-container-jyxvw-ygxuh input[type="text"], div#tda-customizer-customization-option-value-container-ufhqiq-4fhome input[type="text"], div#tda-customizer-customization-option-value-container-99ss4q-l21aqo input[type="text"], div#tda-customizer-customization-option-value-container-mow9gf-rdumnk input[type="text"], div#tda-customizer-customization-option-value-d1b2oa input[type="text"], div#tda-customizer-customization-option-value-sz6opv input[type="text"], div#tda-customizer-customization-option-value-container-0sxm96-b7gwz input[type="text"], div#tda-customizer-customization-option-value-container-rjsag-754asm input[type="text"], div#tda-customizer-customization-option-value-container-phzdbe-0jglxd input[type="text"]').keyup(function() { 
                this.value = this.value.toLocaleUpperCase(); 
            }); 
});
// 3D cart drawer js end 18 July 2024 

document.addEventListener('DOMContentLoaded', function () {
var removeInterval = setInterval(function () {
        var target = $("body.template-product.template-3d-configurator div#rbr-container-element-fbt");

        if (target.length > 0) {
            target.remove(); 
            clearInterval(removeInterval); 
            console.log("rbr-container-element-fbt removed from DOM.");
        }
    }, 1000); 

$("body").on("click", ".tda-accordion-panel .tda-customizer-select-button-customization-option-value .tda-customizer-customization-option-value-title", function() {
    // Clear the value of the input
    $(this).parents(".tda-accordion-panel").find(".tda-customizer-customization-option-value-selected input").val('');
    //$('.tda-customizer-customization-options-container .tda-customizer-customization-option-value-selected input').val('');
});
$("body").on("click", "#tda-customizer-customization-option-value-y017i6 .tda-customizer-customization-option-value-title", function() {
$(".tda-file-upload-content").find(".tda-remove-image").trigger("click");
});

  $(".tda-customizer-variant-price-container").after($(".custom-3D-product-desc-jtpl").html());
      $(".tda-customizer-footer-right").prepend(`<div class="tda-customizer-tax-included production-title-jtpl new-production-time-jtpl">
            Production takes approximately 4 to 5 weeks, and the item will be dispatched directly from Thailand.<br>
            Wholesale discounts are available for gyms and clubs.<br>
          </div>`);
 });

$(document).ready(function() {

  $("body").on("click","#tda-customizer-customization-option-value-xxt0sx,#tda-customizer-customization-option-value-ve3j9,.tda-customizer-customization-options-container button.tda-accordion",function(){
    //alert("hai");
      $('#tda-customizer-section-btn-51670382313837-gw6q7p span').eq(0).addClass('yokkao-font-text-jtpl');
    var checkElement = setInterval(function() {
        if ($('.tda-customizer-customization-options-container button#tda-customizer-section-btn-51670382313837-gw6q7p').length) {
            $('.tda-customizer-customization-options-container button#tda-customizer-section-btn-51670382313837-gw6q7p').addClass('tda-accordion-active');
            $('.tda-customizer-customization-options-container div#tda-customizer-section-panel-51670382313837-gw6q7p').addClass('overflow-visible');
            $('.tda-customizer-customization-options-container div#tda-customizer-section-panel-51670382313837-gw6q7p').css({
                'max-height': 'min-content',
                'padding': '20px'
            });
            clearInterval(checkElement);
        }
    }, 100);
     
  });
$(document).click(function(event) {
    if (!$(event.target).is('#tda-customizer-customization-option-value-xxt0sx,#tda-customizer-customization-option-value-ve3j9')) {
        $('#tda-customizer-section-btn-51670382313837-gw6q7p span').eq(0).removeClass('yokkao-font-text-jtpl');
    }
   
});

// Use js for custom heavy bag start
    $("body").on("click",".tda-customizer-customization-option-value-list div#tda-customizer-customization-option-value-lz0zyp",function(){
       $('.tda-customizer-customization-options-container .tda-customizer-section-btn-51944615379309-6dhd0g, span.add-img-with-add-text-jtpl').css('display','none');
      });
        $("body").on("click",".tda-customizer-customization-option-value-list div#tda-customizer-customization-option-value-j3ci5q",function(){
       $('.tda-customizer-customization-options-container .tda-customizer-section-btn-51944615379309-6dhd0g, span.add-img-with-add-text-jtpl').css('display','block');
      });
      $("body").on("click",".tda-customizer-customization-option-value-list div#tda-customizer-customization-option-value-rwr11i",function(){
       $('.tda-customizer-customization-options-container .tda-customizer-section-btn-51944615379309-towws, span.add-img-with-add-text-jtpl').css('display','none');
      });
        $("body").on("click",".tda-customizer-customization-option-value-list div#tda-customizer-customization-option-value-y017i6",function(){
       $('.tda-customizer-customization-options-container .tda-customizer-section-btn-51944615379309-towws, span.add-img-with-add-text-jtpl').css('display','block');
      });
    jQuery("body").on("change", "#tda-customizer-customization-option-dropdown-mx5hsv", function() {
    if (jQuery("#tda-customizer-customization-option-value-lz0zyp").hasClass("tda-customizer-customization-option-value-selected")) {
      jQuery('.tda-customizer-customization-options-container .tda-customizer-section-btn-51944615379309-6dhd0g, span.add-img-with-add-text-jtpl').css('display', 'none');
    }
      if (jQuery("#tda-customizer-customization-option-value-rwr11i").hasClass("tda-customizer-customization-option-value-selected")) {
      $('.tda-customizer-customization-options-container .tda-customizer-section-btn-51944615379309-towws, span.add-img-with-add-text-jtpl').css('display','none');
    }
  });
     
  // Use js for custom heavy bag end

    // Use js for custom Freestyle Kicking Pads start
function updateCustomizerUI() {
  if ($('#tda-customizer-customization-option-value-fp4094').hasClass('tda-customizer-customization-option-value-selected')) {
    $('.tda-customizer-customization-options-container .tda-customizer-section-btn-52089336070509-6u05yh, span.add-img-with-add-text-jtpl').css('display', 'none');
  }
  if ($('#tda-customizer-customization-option-value-2xlpq').hasClass('tda-customizer-customization-option-value-selected')) {
    $('.tda-customizer-customization-options-container .tda-customizer-section-btn-52089336070509-6u05yh, span.add-img-with-add-text-jtpl').css('display', 'block');
  }

  if ($('#tda-customizer-customization-option-value-i37om').hasClass('tda-customizer-customization-option-value-selected')) {
    $('.tda-customizer-customization-options-container .tda-customizer-section-btn-52089336070509-bc4mje, span.add-img-with-add-text-jtpl').css('display', 'none');
  }
}
$('body').on('click', '.tda-customizer-customization-option-value-list > div', function () {
  setTimeout(updateCustomizerUI, 50);
});

  // Use js for custom Freestyle Kicking Pads end
   
    var checkElement = setInterval(function() {
        if ($('.tda-customizer-customization-options-container button#tda-customizer-section-btn-51670382313837-gw6q7p').length) {
            $('.tda-customizer-customization-options-container button#tda-customizer-section-btn-51670382313837-gw6q7p').addClass('tda-accordion-active');
            $('.tda-customizer-customization-options-container div#tda-customizer-section-panel-51670382313837-gw6q7p').addClass('overflow-visible');
            $('.tda-customizer-customization-options-container div#tda-customizer-section-panel-51670382313837-gw6q7p').css({
                'max-height': 'min-content',
                'padding': '20px'
            });
            clearInterval(checkElement);
        }
    }, 100);

     $("body").on("click","#tda-customizer-section-btn-51670382313837-i1gma, #tda-customizer-section-btn-51670382313837-8o6855, #tda-customizer-section-btn-51670382313837-v6sxn4s",function(){
  if($("#tda-customizer-customization-option-value-ve3j9").hasClass("tda-customizer-customization-option-value-selected") || $("#tda-customizer-customization-option-value-xxt0sx").hasClass("tda-customizer-customization-option-value-selected")){
                  setTimeout(function() {
      $('#tda-customizer-section-btn-51670382313837-gw6q7p span').eq(0).addClass('yokkao-font-text-jtpl');
                  },400);
  } else {
   
      $('#tda-customizer-section-btn-51670382313837-gw6q7p span').eq(0).removeClass('yokkao-font-text-jtpl');
  }
});


// Use js for custom heavy bag start
    $('.tda-customizer-customization-options-container #tda-customizer-section-panel-51944615379309-towws')
        .after('<span class="add-img-with-add-text-jtpl">OR</span>');
    
    // If you want to check periodically, use setInterval
    var intervalId = setInterval(function() {
        // Check if the button exists
        if ($('.tda-customizer-customization-options-container #tda-customizer-section-panel-51944615379309-towws').length) {
            // Add the span only once
            if (!$('.add-img-with-add-text-jtpl').length) {
                $('.tda-customizer-customization-options-container #tda-customizer-section-panel-51944615379309-towws')
                    .after('<span class="add-img-with-add-text-jtpl">OR</span>');
            }
            // Optionally, clear the interval once done
            clearInterval(intervalId);
        }
    }, 1000);  
  // Use js for custom heavy bag end

   // Use js for custom Freestyle Kicking Pads start
    $('.tda-customizer-customization-options-container #tda-customizer-section-panel-52089336070509-bc4mje')
        .after('<span class="add-img-with-add-text-jtpl">OR</span>');
    
    // If you want to check periodically, use setInterval
    var intervalId = setInterval(function() {
        // Check if the button exists
        if ($('.tda-customizer-customization-options-container #tda-customizer-section-panel-52089336070509-bc4mje').length) {
            // Add the span only once
            if (!$('.add-img-with-add-text-jtpl').length) {
                $('.tda-customizer-customization-options-container #tda-customizer-section-panel-52089336070509-bc4mje')
                    .after('<span class="add-img-with-add-text-jtpl">OR</span>');
            }
            // Optionally, clear the interval once done
            clearInterval(intervalId);
        }
    }, 1000);  
  // Use js for custom Freestyle Kicking Pads end

  function updateLogoCenterButton() {
  var noSelected = $('#tda-customizer-customization-option-value-2xlpq')
    .hasClass('tda-customizer-customization-option-value-selected');

  if (noSelected) {
    // NO selected → button show
    $('#tda-customizer-section-btn-53744510108013-6u05yh').css('display', 'block');
  } else {
    // YES selected → button hide
    $('#tda-customizer-section-btn-53744510108013-6u05yh').css('display', 'none');
  }
}

// click event
$('body').on('click', '#tda-customizer-customization-option-value-2xlpq, #tda-customizer-customization-option-value-fp4094', function () {
  setTimeout(updateLogoCenterButton, 50);
});

// page load pe bhi run karo (important)
$(document).ready(function () {
  updateLogoCenterButton();
});
function updateNameCenterButton() {
  var noSelected = $('#tda-customizer-customization-option-value-0yjdj')
    .hasClass('tda-customizer-customization-option-value-selected');

  if (noSelected) {
    // NO selected → show button + panel
    $('#tda-customizer-section-btn-53744510108013-bc4mje').show();
    $('#tda-customizer-section-panel-53744510108013-e23kub').show();
  } else {
    // YES selected → hide button + panel
    $('#tda-customizer-section-btn-53744510108013-bc4mje').hide();
    $('#tda-customizer-section-panel-53744510108013-e23kub').hide();
  }
}

// click event
$('body').on('click', '#tda-customizer-customization-option-value-0yjdj, #tda-customizer-customization-option-value-i37om', function () {
  setTimeout(updateNameCenterButton, 50);
});

// page load
$(document).ready(function () {
  updateNameCenterButton();
});
   
});


